import React, { useContext, useState } from "react";
import AICCRuleBuilderUtils from "utils/AICCRuleBuilderUtils";

export const QueryContext = React.createContext({
  query: [],
  setQuery: (query) => {},
});

export const QueryContextProvider = (props) => {
  const [query, setQuery] = useState([AICCRuleBuilderUtils.defaultQuery()]);

  return (
    <QueryContext.Provider
      value={{
        query,
        setQuery,
      }}
      {...props}
    />
  );
};

export const useQueryContext = () => {
  const queryContextProps = useContext(QueryContext);

  return {
    ...queryContextProps,
  };
};
